<template>
  <div class="electronic_form" data-name="intern_score_form">
    <div class="form_title mb-5">校外實習成績考評表</div>
    <div class="white_block" :class="{'hidden': !!hiddenMsg}">
      <div id="create_enter_area_top"></div>
      <div id="intern_score_outer">
        <div id="create_enter_area_enterprise"></div>
        <div id="create_enter_area_teacher"></div>
      </div>
      <div id="create_enter_area_admin"></div>
      <rank-comparison-table/>
      <div v-if="editType == 'edit'" class="btn_area">
        <button class="btn--pill pill blue" @click="back">返回</button>
        <button class="btn--pill pill blue" @click.prevent="submitData">確認送出</button>
      </div>
      <div v-if="editType == 'view'" class="btn_area">
        <button class="btn--pill pill blue" @click="back">返回</button>
        <button class="btn--pill pill blue" @click="downloadPdf">下載</button>
        <button class="btn--pill pill blue" @click="printPdf">列印</button>
      </div>
    </div>
    <div v-if="hiddenMsg" class="white_block" id="unfilled">{{ hiddenMsg }}</div>
    <intern-form-datetime-popup
      v-if="editType == 'edit'"
      v-model="datetimePopupValue"
      format="yyyy/LL/dd"
      :is-open="datetimePopupOpen"
      @close="datetimePopupClose"
      @confirm="datetimePopupConfirm"
    ></intern-form-datetime-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InternFormDatetimePopup from '~components/common/forms/InternFormDatetimePopup'
import RankComparisonTable from '~components/common/forms/RankComparisonTable'
import { enter_area } from '~components/common/enter_area.js'
import { fullwidth_to_halfwidth } from '~components/common/assist.js'
import {
  InternScoreFormBlueprintTop,
  InternScoreFormBlueprintEnterprise,
  InternScoreFormBlueprintTeacher,
  InternScoreFormBlueprintAdmin,
  InternScoreFormBlueprintAdminDisabled,
  InternScoreFormBlueprintTeacherDisabled,
  InternScoreFormBlueprintEnterpriseDisabled,
  InternScoreFormBlueprintTopDisabled,
} from '~components/common/forms/blueprints/InternScoreForm.js'
import '~style/components/enter_area.css'
import '~style/components/electronic_form.css'
export default {
  name: 'InternScoreForm',
  components: {
    InternFormDatetimePopup,
    RankComparisonTable,
  },
  props: {
    isEnterprise: {
      type: Boolean,
      default: false
    },
    isTeacher: {
      type: Boolean,
      default: false
    },
    editType: {
      type: String,
      default: ''
    },
    hiddenMsg: {
      type: String,
      default: ''
    },
    backPath: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      enterAreaTop: null,
      enterAreaEnterprise: null,
      enterAreaTeacher: null,
      enterAreaAdmin: null,
      datetimePopupValue: '',
      datetimePopupOpen: false,
    };
  },
  async mounted () {
    this.togglePageLoader(true);
    let blueprint_top = this.isEnterprise ? InternScoreFormBlueprintTop : InternScoreFormBlueprintTopDisabled;
    let blueprint_enterprise = this.isEnterprise ? InternScoreFormBlueprintEnterprise : InternScoreFormBlueprintEnterpriseDisabled;
    let blueprint_teacher = this.isTeacher ? InternScoreFormBlueprintTeacher : InternScoreFormBlueprintTeacherDisabled;

    this.enterAreaTop = new enter_area($('#create_enter_area_top')[0], blueprint_top, this.editType == 'view');
    this.enterAreaEnterprise = new enter_area($('#create_enter_area_enterprise')[0], blueprint_enterprise, this.editType == 'view');
    this.enterAreaTeacher = new enter_area($('#create_enter_area_teacher')[0], blueprint_teacher, this.editType == 'view');
    this.enterAreaAdmin = new enter_area($('#create_enter_area_admin')[0], InternScoreFormBlueprintAdminDisabled, this.editType == 'view');

    this.enterAreaEnterprise.set_enter_blocks_onclick_by_custom_type('date', this.openDatetimePopup);

    this.$emit('load', {
      enterAreaTop: this.enterAreaTop,
      enterAreaEnterprise: this.enterAreaEnterprise,
      enterAreaTeacher: this.enterAreaTeacher,
      enterAreaAdmin: this.enterAreaAdmin,
    });
  },
  methods: {
    ...mapActions('layouts', [
      'newToast',
      'togglePageLoader',
    ]),
    submitData () {
      if(this.editType != 'edit' || !this.enterAreaTop || !this.enterAreaEnterprise || !this.enterAreaTeacher || !this.enterAreaAdmin) return;
      if(this.valid()) return;
      let form_data = [
        this.enterAreaTop.get_form_data(),
        this.enterAreaEnterprise.get_form_data(),
        this.enterAreaTeacher.get_form_data(),
        this.enterAreaAdmin.get_form_data(),
      ];
      form_data = Object.assign({}, ...form_data);
      for(let key in form_data) {
        if(typeof form_data[key] == 'string') {
          form_data[key] = fullwidth_to_halfwidth(form_data[key]);
        }
      }
      this.$emit('submitData', form_data);
    },
    valid() {
      if(this.isEnterprise) {
        if(!this.enterAreaTop.valid() || !this.enterAreaEnterprise.valid()) {
          this.newToast({
            variant: 'warning',
            message: '請確認所有欄位是否都有填寫完整'
          });
          return true;
        }
      }
      else if(this.isTeacher) {
        if(!this.enterAreaTeacher.valid()) {
          this.newToast({
            variant: 'warning',
            message: '請確認所有欄位是否都有填寫完整'
          });
          return true;
        }
      }
    },
    openDatetimePopup(enter_block) {
      this.datetimePopupTarget = enter_block;
      this.datetimePopupValue = enter_block.get_value() || '';
      this.datetimePopupOpen = true;
    },
    datetimePopupClose () {
      this.datetimePopupOpen = false;
    },
    datetimePopupConfirm (datetime) {
      this.datetimePopupValue = datetime;
      this.datetimePopupTarget.set_value(datetime);
      this.datetimePopupTarget = null;
    },
    back() {
      if(this.backPath) {
        this.$router.push({ path: this.backPath });
      }
      else {
        $router.back();
      }
    },
    downloadPdf() {
      let blueprint = [
        InternScoreFormBlueprintTop,
        InternScoreFormBlueprintEnterprise,
        InternScoreFormBlueprintTeacher,
        InternScoreFormBlueprintAdmin,
      ].flat();
      this.$emit('downloadPdf', blueprint);
    },
    printPdf() {
      let blueprint = [
        InternScoreFormBlueprintTop,
        InternScoreFormBlueprintEnterprise,
        InternScoreFormBlueprintTeacher,
        InternScoreFormBlueprintAdmin,
      ].flat();
      this.$emit('printPdf', blueprint);
    },
  }
}
</script>
<style lang="scss" scoped>
.form_title {
  color: #235AA3;
  font-size: 24px;
  line-height: 35px;
  font-weight: bold;
  text-align: center;
}
.btn_area {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 16px;
  @media (max-width: 768px) { margin-top: 21px; }
}

@media (min-width: 1024px) {
  #intern_score_outer { display: flex; gap: 42px; align-items: flex-end; }
  #intern_score_outer > div { flex: 50%; }
}

.hidden { display: none; }
#unfilled {
  text-align: center;
  padding: 120px 30px;
}
</style>
